export function KRW(value: number) {
  return "₩" + value.toLocaleString()
}
